import Perspective from '../../../plugins/behaviors/containerperspective/ContainerPerspective.js';
export default Perspective;